import { useEffect, useState } from "react";
import axios from "axios";
import { API, PAYHIP_PRODUCTS as FALLBACK } from "@/lib/config";

/**
 * Fetches the live product catalog synced from Payhip.
 * Returns a stable list — falls back to the bundled static list
 * only while the initial fetch is in flight or on error.
 */
export default function useProducts() {
  const [products, setProducts] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/products`, {
          headers: { "Cache-Control": "no-cache" },
        });
        if (cancelled) return;
        if (Array.isArray(data) && data.length > 0) {
          setProducts(data);
        }
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { products, loading, error };
}
